import * as Yup from 'yup';


const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "name",
    label: "Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "color",
    name: "label_color",
    label: "Label Color",
    helperText: "Select color or type color like, lightblue, or hex #ffffff",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "description",
    label: "Description",
    type: "text",
    multiline: true,
    rows: 4,
    size: {xs: 12, lg: 12},
  }
]

const initialValues = {
  name: '',
  label_color: '#ffffff',
  service_type: 'service',
  description: ''
}

const schema = Yup.object().shape({
  name: Yup.string().required('Required'),
});

export { fields, schema, initialValues };